<template>
  <!-- <div>
    <div v-if="isFilterApplied" class="d-flex justify-content-end mb-3">
      <a
        href="javascript:;"
        class="btn btn-secondary w-60 display-6"
        @click="handleClearFilters"
      >
        Clear Filters
      </a>
    </div>
  </div> -->
  <form @submit.prevent="handleFilters">
    <div class="row filter-row mb-3">
      <div class="col-sm-6 col-md-2">
        <div class="input-block mt-1 mb-0">
          <div class="filter-label-row">
            <label class="filter-label">Rec. Dept.</label>
            <i
              v-if="filters.recommend_department_id"
              @click="handleClearOneFilter('recommend_department_id')"
              class="fa-solid fa-x filter-clear-icon"
            ></i>
          </div>
          <vue-select
            :style="`${
              filters.recommend_department_id &&
              'border-bottom: var(--primary-color) 2px solid; border-radius: 6px;'
            }`"
            :options="departments"
            v-model="filters.recommend_department_id"
            placeholder="Select Department"
            id="design2"
          />
        </div>
      </div>
      <div class="col-sm-6 col-md-2">
        <div class="input-block mt-1 mb-0 text-truncate">
          <div class="filter-label-row">
            <label class="filter-label">Rec. Desig.</label>
            <i
              v-if="filters.recommend_designation_id"
              @click="handleClearOneFilter('recommend_designation_id')"
              class="fa-solid fa-x filter-clear-icon"
            ></i>
          </div>
          <vue-select
            :style="`${
              filters.recommend_designation_id &&
              'border-bottom: var(--primary-color) 2px solid; border-radius: 6px;'
            }`"
            :options="designations"
            v-model="filters.recommend_designation_id"
            placeholder="Select Designation"
            id="design4"
          />
        </div>
      </div>
      <div class="col-sm-6 col-md-2">
        <div class="input-block mt-1 mb-0">
          <div class="filter-label-row">
            <label class="filter-label">Gender</label>
            <i
              v-if="filters.gender_id"
              @click="handleClearOneFilter('gender_id')"
              class="fa-solid fa-x filter-clear-icon"
            ></i>
          </div>
          <vue-select
            :style="`${
              filters.gender_id &&
              'border-bottom: var(--primary-color) 2px solid; border-radius: 6px;'
            }`"
            :options="genders"
            v-model="filters.gender_id"
            placeholder="Select Gender"
          />
        </div>
      </div>
      <div class="col-sm-6 col-md-2">
        <div class="input-block mt-1 mb-0">
          <div class="filter-label-row">
            <label class="filter-label">Location</label>
            <i
              v-if="filters.apply_location"
              @click="handleClearOneFilter('apply_location')"
              class="fa-solid fa-x filter-clear-icon"
            ></i>
          </div>
          <vue-select
            :style="`${
              filters.apply_location &&
              'border-bottom: var(--primary-color) 2px solid; border-radius: 6px;'
            }`"
            :options="locations"
            v-model="filters.apply_location"
            placeholder="Select Location"
          />
        </div>
      </div>
      <div class="col-sm-6 col-md-2">
        <div class="input-block mt-1 mb-0">
          <div class="filter-label-row">
            <label class="filter-label">Experience</label>
            <i
              v-if="filters.experience"
              @click="handleClearOneFilter('experience')"
              class="fa-solid fa-x filter-clear-icon"
            ></i>
          </div>
          <vue-select
            :style="`${
              filters.experience &&
              'border-bottom: var(--primary-color) 2px solid; border-radius: 6px;'
            }`"
            :options="experiences"
            v-model="filters.experience"
            placeholder="Select Experience"
          />
        </div>
      </div>
      <div class="col-sm-6 col-md-2">
        <div class="input-block mt-1 mb-0">
          <label class="filter-label">Applicant Id</label>
          <input
            type="text"
            class="form-control filter-input"
            v-model="filters.applicant_id"
          />
        </div>
      </div>

      <!-- <div class="col-md-9"></div> -->
      <div class="d-flex align-items-end justify-content-end col-sm-6 col-md-12 gap-2 mt-1">
        <button
          type="submit"
          class="btn btn-filter"
          @click.prevent="handleFilters"
        >
          <i class="fa-solid fa-filter me-1"></i> Search
        </button>
        <button
          type="button"
          class="btn btn-reset"
          @click.prevent="resetAllFilters"
        >
          <i class="fa-solid fa-rotate-left me-1"></i> Reset
        </button>
      </div>
    </div>
  </form>
</template>

<script>
import DepartmentService from "@/services/DepartmentService";
import GenderService from "@/services/GenderService";
import CityService from "@/services/CityService";
import ExperienceService from "@/services/ExperienceService";
import DesignationService from "@/services/DesignationService";

export default {
  data() {
    return {
      select2: null,
      Company: ["Select Company", "Global Technologies", "Delta Infotech"],
      isFocused: false,
      filters: {
        recommend_department_id: "",
        recommend_designation_id: "",
        gender_id: "",
        apply_location: "",
        experience: "",
        applicant_id: "",
      },
      isFocusedOn: false,
      departments: [],
      genders: [],
      locations: [],
      experiences: [],
      designations: [],
      jobs: [],
      priorities: ["low", "medium", "high"],
      searched: false,
    };
  },
  props: {},
  methods: {
    handleFilters(value) {
      //console.log(JSON.stringify(this.filters));
      this.searched = true;
      this.$emit("apply-filters", this.filters);
      // Perform any action on change
    },

    handleClearOneFilter(fileName) {
      this.filters[fileName] = "";
      const filtersHasProperty = Object.values(this.filters).filter(
        (el) => !!el
      ).length;
      if (this.searched) {
        this.$emit("apply-filters", this.filters);
      }
      if (!filtersHasProperty) {
        this.searched = false;
      }
    },

    resetAllFilters() {
      // Reset all filter values to empty strings
      Object.keys(this.filters).forEach((key) => {
        this.filters[key] = "";
      });

      // Emit updated filters
      this.$emit("apply-filters", this.filters);

      // Reset search state
      this.searched = false;
    },

    // async fetchEmploymentStatuses() {
    //   try {
    //     const response = await DutyTypeService.fetch();
    //     this.employmentStatuses = response?.data.map((el) => el.duty_type);
    //   } catch (error) {
    //     console.error("Error fetching employment statuses:", error);
    //   }
    // },
    async fetchRecruiters() {
      try {
        const response = await DesignationService.getDesignations();
        this.designations = response?.data.map((el) => el.designation_name);
      } catch (error) {
        console.error("Error fetching designations:", error);
      }
    },
    async fetchGenders() {
      try {
        const response = await GenderService.getGenders();
        this.genders = response?.data.map((e) => e.gender_name);
      } catch (error) {
        console.error("Error fetching jobs:", error);
      }
    },
    async fetchLocations() {
      try {
        const response = await CityService.getCities();
        this.locations = response?.data.map((e) => e.city_name);
      } catch (error) {
        console.error("Error fetching jobs:", error);
      }
    },
    async fetchExperiences() {
      try {
        const response = await ExperienceService.fetch();
        this.experiences = response?.data.map((e) => e.experience);
      } catch (error) {
        console.error("Error fetching jobs:", error);
      }
    },

    async fetchDepts() {
      try {
        const response = await DepartmentService.getDepartments();
        this.departments = response?.data.map((el) => el.name);
      } catch (error) {
        console.error("Error fetching departments:", error);
      }
    },

    handleClearFilters() {
      this.$emit("apply-filters", {});
      this.filters = {
        recommend_department_id: "",
        recommend_designation_id: "",
        gender_id: "",
        apply_location: "",
        experience: "",
        applicant_id: "",
      };
      this.searched = false;
    },
    async fetchServices() {
      try {
        // this.fetchEmploymentStatuses();
        await this.fetchRecruiters();
        await this.fetchDepts();
        await this.fetchGenders();
        await this.fetchLocations();
        await this.fetchExperiences();
      } catch (error) {
        console.log("error fetching services", error);
      }
    },
  },
  created() {
    this.searched = false;
    this.fetchServices();
    // this.campaigns = (await CampaignService.getCampaigns())?.data.map(
    //   (el) => el.campaigns
    // );
    // this.projects = (await EmployeeProjectService.fetch())?.data.map(
    //   (el) => el.project_name
    // );
    // this.sections = (await SectionService.getSections())?.data.map(
    //   (el) => el.section_name
    // );

    // through ID
    // this.designations = (await DesignationService.getDesignations()).data.map(el => ({id: el.id, text: el.designation_name}));
    // this.divisions = (await DivisionService.getDivisions()).data.map(el => ({id: el.id, text:el.name}));

    // this.campaigns = (await CampaignService.getCampaigns()).data.map(el => ({id:el.id, text: el.campaigns}));
    // this.sections = (await SectionService.getSections()).data.map(el => ({id: el.id, text: el.section_name}));
  },

  computed: {
    isFilterApplied() {
      const filtersHasProperty = Object.values(this.filters).filter(
        (el) => !!el
      ).length;

      return this.searched && filtersHasProperty;
    },
  },
};
</script>

<style scoped>
.filter-label-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 4px;
}

.filter-label {
  font-size: 12.5px;
  font-weight: 600;
  color: #878787;
  margin: 0;
  padding: 0;
}

.filter-clear-icon {
  font-size: 10px;
  color: #8c9bb5;
  cursor: pointer;
  transition: color 0.2s ease;
}

.filter-clear-icon:hover {
  color: var(--primary-color);
}

:deep(.filter-input) {
  height: 36px;
  border-radius: 6px;
  border: 1px solid #dcdfe6;
  font-size: 12.5px;
  padding: 6px 12px;
  transition: all 0.2s ease;
}

:deep(.filter-input:focus) {
  border-color: var(--primary-color);
  box-shadow: 0 0 0 3px color-mix(in srgb, var(--primary-color) 10%, transparent);
}

:deep(.select2-container--default .select2-selection--single) {
  height: 36px !important;
  border-radius: 6px !important;
  border: 1px solid #dcdfe6 !important;
  transition: all 0.2s ease;
}

:deep(.select2-container--default .select2-selection--single .select2-selection__rendered) {
  font-size: 12.5px !important;
  line-height: 34px !important;
  padding-left: 12px !important;
  padding-right: 30px !important;
}

:deep(.select2-container--default .select2-selection--single .select2-selection__arrow) {
  height: 34px !important;
}

:deep(.select2-container--open .select2-selection--single) {
  border-color: var(--primary-color) !important;
  box-shadow: 0 0 0 3px color-mix(in srgb, var(--primary-color) 10%, transparent);
}

.btn-filter {
  height: 36px;
  padding: 0 14px;
  font-size: 12.5px;
  font-weight: 700;
  border-radius: 6px;
  background-color: var(--primary-color);
  border: 1px solid var(--primary-color);
  color: #ffffff;
  transition: all 0.2s ease;
  cursor: pointer;
}

.btn-filter:hover {
  background-color: color-mix(in srgb, var(--primary-color) 90%, #000);
  border-color: color-mix(in srgb, var(--primary-color) 90%, #000);
  color: #ffffff;
}

.btn-reset {
  height: 36px;
  padding: 0 14px;
  font-size: 12.5px;
  font-weight: 700;
  border-radius: 6px;
  background-color: #ffffff;
  border: 1px solid #dcdfe6;
  color: #606266;
  transition: all 0.2s ease;
  cursor: pointer;
}

.btn-reset:hover {
  background-color: #f5f7fa;
  border-color: #c0c4cc;
  color: #303133;
}
</style>
